import { Injectable } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { BehaviorSubject, Subject, EMPTY } from 'rxjs';
import { ProductChangeVM } from '../../../../../models/ProductChangeVM';

@Injectable()
export class EaAddProductSliderModelService {
  public eaAddProductSlider: BehaviorSubject<boolean>;
  public addSidenav: MatSidenav;
  private activeSliderValue: string;
  sliderCloseRqt: Subject<boolean>;
  addModelData: BehaviorSubject<any>;
  initializeProductChangeValue: BehaviorSubject<ProductChangeVM>;
  constructor() {
    this.eaAddProductSlider = new BehaviorSubject(false);
    this.addModelData = new BehaviorSubject(EMPTY);
    this.sliderCloseRqt = new Subject();
    this.initializeProductChangeValue = new BehaviorSubject(null);
  }

  activeSlider(value: string) {
    this.activeSliderValue = value;
    this.activeSliderValue = value;

    if (value === 'EaAddProductSlider') {
      this.eaAddProductSlider.next(true);
      this.addModelData.next(EMPTY);
      this.addSidenav.toggle();
    }
  }

  public setSideNav(sideNavObj: MatSidenav) {
    this.addSidenav = sideNavObj;
  }

  public initializeProductChangeVal(value: ProductChangeVM) {
    this.initializeProductChangeValue.next(value);
  }

  public close() {
    this.addModelData.next(EMPTY);
    this.eaAddProductSlider.next(false);
    this.addSidenav.close();
  }

  public setData<T>(obj: T) {
    this.addModelData.next(obj);
  }
}
